import React from "react";

import { Container, Header } from "semantic-ui-react";

import getBitcoinArticles from "../config/cryptonewsApi";
import ArticleList from "../components/ArticleList";

class News extends React.Component {
  state = {
    articles: [],
    apiError: "",
  };

  async componentDidMount() {
    try {
      const response = await getBitcoinArticles();
      this.setState({ articles: response.articles });
    } catch (error) {
      this.setState({ apiError: "Could not find any articles" });
    }
  }

  render() {
    const { articles, apiError } = this.state;
    return (
      <Container>
        <Header
          as="h2"
          style={{ textAlign: "center", margin: 20, color: "#fff" }}
        >
          Latest Cryptocurrency News
        </Header>
        {articles.length > 0 && <ArticleList articles={articles} />}
        {apiError && <p>Could not fetch any articles. Please try again.</p>}
      </Container>
    );
  }
}
export default News;
